/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuditSummaryRecentActivityDto { 
    /**
     * Count of logs in the last 24 hours
     */
    last24h: number;
    /**
     * Count of logs in the last 7 days
     */
    last7d: number;
    /**
     * Count of logs in the last 30 days
     */
    last30d: number;
}

